import React from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';

import { reactPlugin } from 'app-insights';

import Form from 'components/Form';
import { InformationContainer } from 'components/Containers';
import { Button } from 'components/Buttons';
import { env } from 'env';

const NoActiveApplication = () => (
  <Form title="No Active Application">
    <InformationContainer title="It looks like you don’t currently have an application in progress with us.">
      <p className="text_small">If you would like to start a new application, please click the button below.</p>
      <Button
        onClick={() => {
          window.location.href = `${env.REACT_APP_REPUBLIC_FINANCE_PREQUAL_URL}`;
        }}
        centered
      >
        Get Started
      </Button>
    </InformationContainer>
  </Form>
);

export default withAITracking(reactPlugin, NoActiveApplication, 'NoActiveApplicationPage');
